// extracted by mini-css-extract-plugin
export default {"groupBox":"wClJ30ngaH0le1iGv0cq"};